module.exports = __webpack_public_path__ + "static/Bobcat-E10-w-e14a406463a539dbe733d6a57a20f28d.jpg";